import React from 'react';
import RequestsDetail from 'modules/Requests/RequestsDetail';

const QueueRequestDetail: React.FC = () => {
  return <RequestsDetail isQueue={true} />;
};

export default QueueRequestDetail;
